import { cpf, createValidator, maxLength, minLength, nome, required } from 'util/validation'

import { SalaEsperaFormModel } from './model-videochamada'

export const profParticipanteValidator = createValidator<SalaEsperaFormModel>({
  nomeParticipante: [required, nome(), minLength(5), maxLength(70)],
  cpf: [required, cpf],
})
